






































































































































































































































































































































































import phoneNumber from "@/components/phoneNumber.vue";
// @ts-ignore
import toastificationContent from "@/layouts/components/toastification/toastificationContent";
import i18n from "@/libs/i18n";
import { useChatsStore } from "@/store/useChatsStore";
import { useContactsStore } from "@/store/useContactsStore";
import { getCountriesAsArray, getCountryName } from "@/utils/countries";
import { resolveInitials } from "@/utils/users";
import { computed, defineComponent, ref } from "@vue/composition-api";
import {
    BAvatar,
    BButton,
    BCard,
    BCardText,
    BCol,
    BFormInput,
    BFormSelect,
    BOverlay,
    BRow,
    BSpinner,
    VBTooltip,
} from "bootstrap-vue";
import { isValidPhoneNumber, parsePhoneNumberFromString } from "libphonenumber-js";
import { clone } from "lodash";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { useToast } from "vue-toastification/composition";
import contactLabels from "@/components/contactLabels.vue";

extend("libphonenumber", (phone): boolean => {
    const findCountryCode = ["+", "00"].filter((countryCode) => phone.startsWith(countryCode));
    if (findCountryCode.length === 0) {
        return false;
    }

    return isValidPhoneNumber(phone, "NL");
});

export default defineComponent({
    components: {
        BAvatar,
        BButton,
        BCard,
        BCardText,
        BCol,
        BFormInput,
        BFormSelect,
        BRow,
        BSpinner,
        BOverlay,
        ValidationObserver,
        ValidationProvider,
        contactLabels,
        phoneNumber,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    setup(_, { refs }) {
        const toast = useToast();
        const contactsStore = useContactsStore();
        const chatsStore = useChatsStore();
        contactsStore.fetchMetadataFields();

        const editMode = ref(false);

        // @note clone so we do not mutate the original contact state directly for when we like to cancel editing.
        const contact = computed(() => clone(contactsStore.activeChatContact));
        const updateContact = (): void => {
            // @ts-ignore
            refs.validationRules.validate().then((success) => {
                if (success) {
                    if (!contactsStore.activeChatContact || !contact.value) {
                        return;
                    }

                    contactsStore
                        .updateContact({
                            ...contact.value,
                        })
                        .then(() => {
                            toast({
                                component: toastificationContent,
                                props: {
                                    title: i18n.t("entities.contact.Contact"),
                                    text: i18n.t("toast.update.success", { entity: contact.value?.name }),
                                    icon: "check",
                                    variant: "success",
                                },
                            });

                            editMode.value = false;
                        })
                        .catch((error) => {
                            let errorMessage = i18n.t("contacts.update-error-generic");

                            switch (error.response.data.message) {
                                case "Changing a contacts phone number is not allowed":
                                    errorMessage = i18n.t("contacts.phone-not-editable");
                                    break;
                                case "Changing a contacts email address is not allowed":
                                    errorMessage = i18n.t("contacts.email-not-editable");
                                    break;
                            }

                            toast({
                                component: toastificationContent,
                                props: {
                                    title: i18n.t("entities.contact.Contact"),
                                    text: errorMessage,
                                    icon: "times",
                                    variant: "danger",
                                },
                            });
                        });
                } else {
                    toast({
                        component: toastificationContent,
                        props: {
                            title: i18n.t("entities.contact.Contact"),
                            text: i18n.t("contacts.invalid-input"),
                            icon: "times",
                            variant: "danger",
                        },
                    });
                }
            });
        };

        const parsePhoneNumber = (phone: string): string => {
            if (!phone) {
                return null;
            }

            const findCountryCode = ["+", "00"].filter((countryCode) => phone.startsWith(countryCode));
            if (findCountryCode.length === 0) {
                return phone;
            }

            if (isValidPhoneNumber(phone, "NL")) {
                return parsePhoneNumberFromString(phone, "NL")?.formatInternational();
            }

            return phone;
        };

        return {
            chatsStore,
            contact,
            contactsStore,
            editMode,
            getCountriesAsArray,
            getCountryName,
            parsePhoneNumber,
            resolveInitials,
            updateContact,
        };
    },
});
